import { ref } from 'vue';

const NOVA_POSHTA_LOCALE = 'uk';
const NOVA_POSHTA_PROVIDER_SLUG = 'novaposhta';
const PER_PAGE = 100;

const getData = async (endpoint: string, options: any) => {
  const stringParams = options?.params
    ? `?${new URLSearchParams(options.params).toString()}`
    : '';
  const fullUrl = `/api/delivery${endpoint}${stringParams}`;

  const response = await fetch(fullUrl);
  const json = await response.json();
  return json;
};

const useNovaPoshta = () => {
  const countries = ref([{ id: 'UA', name: 'Україна' }]);

  const cities = ref([]);
  const isCitiesLoading = ref(false);

  const pickupPoints = ref([]);
  const isPickupPointsLoading = ref(false);

  const getCities = async (searchTitle: string = '') => {
    isCitiesLoading.value = true;
    try {
      const data = await getData('/cities', {
        params: {
          provider_slug: NOVA_POSHTA_PROVIDER_SLUG,
          language_code: NOVA_POSHTA_LOCALE,
          search_title: searchTitle,
          per_page: PER_PAGE,
        },
      });
      isCitiesLoading.value = false;
      cities.value = data?.data || [];
      return data;
    } catch (error) {
      isCitiesLoading.value = false;
      console.error('Error fetching Nova Poshta cities:', error);
      return [];
    }
  };

  const getPickupPoints = async (
    cityId: number,
    searchAddress: string = '',
  ) => {
    isPickupPointsLoading.value = true;
    try {
      const data = await getData('/pickup-points', {
        params: {
          city_id: cityId,
          provider_slug: NOVA_POSHTA_PROVIDER_SLUG,
          language_code: NOVA_POSHTA_LOCALE,
          search_address: searchAddress,
          per_page: PER_PAGE,
        },
      });
      isPickupPointsLoading.value = false;
      pickupPoints.value = data?.data || [];
      return data;
    } catch (error) {
      isPickupPointsLoading.value = false;
      console.error('Error fetching Nova Poshta pickup points:', error);
      return [];
    }
  };

  const resetSearch = () => {
    cities.value = [];
    pickupPoints.value = [];
  };

  return {
    countries,
    cities,
    pickupPoints,
    getCities,
    getPickupPoints,
    resetSearch,
    isCitiesLoading,
    isPickupPointsLoading,
  };
};

export default useNovaPoshta;
